import React, {Component} from 'react';
import Sectitle from '../Title/Sectitle';
import Doc from './Doc';

class Docs extends Component {
    render(){
        var {title, docs}= this.props;
        return(
            <section className="experts_team_area doc_pad">
                <div className="container">
                    <Sectitle sClass="text-center mb_50 hemdahl-text-dark" Title={title} tClass="t_color2" />
                    <div className="row d-flex justify-content-center">
                        {docs.map(doc =>
                            <div className="col-md-5">
                                <Doc teamImage={doc.teamImage} fileName={doc.fileName}/>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        )
    }
}
export default Docs;